(function(angular) {
	'use strict';

	var COLUMN_ACTION_CLEAR = 'CLEAR_SORT';

	var COLUMN_ACTION_SET_SORT = 'SET_SORT';

	var COLUMN_ACTION_SORT_OPTION = 'SORT';

	var COLUMN_ACTION_SORT_DESC = 'DESC';

	var COLUMN_ACTION_SORT_ASC = 'ASC';

	var COLUMN_ACTION_DISABLE_SORTING = 'DISABLE_SORTING';

	var COLUMN_ACTION_ENABLE_SORTING = 'ENABLE_SORTING';

	var ROW_ACTION_SELECT = 'SELECT';

	var ROW_ACTION_UNSELECT = 'UNSELECT';

	var ROW_SELECT_IF_INDEX = 'ROW_SELECT_FOR_INDEX';

	var IS_ROW_SELECTED = 'IS_ROW_SELECTED';

	var core = angular.module('Core');

	var TABLE_KEY = 'STL-TABLE';

	/**
	 * Define utils for the stl table
	 */
	core.service('StlTableUtils', [function() {
			this.getDefaultPagingConfig = function(minPage) {
				var min = 30;
				if (minPage) {
					min = minPage;
				}
				return {
					//count: 0,
					//selectedPage: 0,
					pageFormating: [min, 100]//, //Optionnal
							//totalElementsPerPage: min //Optionnal but if included pageFormating is required
				};
			};
		}]);

	core.directive('stlTable', ['$timeout', 'FiltersService', function($timeout, FiltersService) {

			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				//template: '<div class="stl-table"><div class="table-responsive" ng-transclude></div></div>',
				template: '<div class="stl-table" ng-transclude></div>',
				scope: {
					notification: '&?',
					selectNotification: '&?',
					control: '=?',
					model: '=',
					options: '=?',
					localSort: '=?'
				},
				/**
				 * options :
				 * disableSorting : true // disable the table sorting
				 * defaultSortColumn : 'column key name' // the default sorted column
				 * defaultSortDesc : true to sort desc
				 * selectionMode: (NONE, SINGLE, MULTIPLE) default "MULTIPLE"
				 */
				link: function(scope, element, attribute, controller) {
					$('table', element).addClass('table-hover');
					$('table', element).addClass('table');
					$('table.stl-table-paging', element).removeClass('table');
					$('table.stl-table-paging', element).removeClass('table-hover');
				},
				controller: ['$scope', '$element', function($scope, $element) {
						var self = this;
						var sortingDisabled = false;
						var uniqueKey = null;

						this.selectionMode = 'MULTIPLE';

						//Key : index , value : obejct
						var selectedObjects = {};
						var currentSortedColumn = null;
						var currentSelectedPage = null;
						var currentPageFormating = null;
						var currentSortDesc = null;
						var headerMap = {};
						var rowMap = {};

						//Options
						this.loadOptions = function() {
							if ($scope.options !== undefined) {
								if ($scope.options['disableSorting'] !== undefined && $scope.options['disableSorting'] === true) {
									sortingDisabled = true;
								}
								if ($scope.options['defaultSortColumn'] !== undefined) {
									currentSortedColumn = $scope.options['defaultSortColumn'];
								}
								if ($scope.options['defaultSortDesc'] !== undefined) {
									currentSortDesc = $scope.options['defaultSortDesc'];
								}
								if ($scope.options['selectionMode'] !== undefined) {
									this.selectionMode = $scope.options['selectionMode'];
								}
								if ($scope.options.uniqueKey) {
									uniqueKey = TABLE_KEY + '-' + $scope.options.uniqueKey;
									var storage = FiltersService.getFilter(uniqueKey);
									if (storage) {
										currentSortedColumn = storage['column'];
										currentSortDesc = storage['desc'];
										currentSelectedPage = storage['currentSelectedPage'];
										currentPageFormating = storage['currentPageFormating'];
									}
								}
							}
						};
						this.loadOptions();

						if ('localSort' in $scope) {
							$scope.localSort = {
								column: currentSortedColumn,
								dir: currentSortDesc

							};
						}

						$scope.toggleSelectLine = function($event, data) {
							$($event).addClass('active');
						};
						this.sendParentControllerNotification = function() {
							$scope.notification({
								sortColumnKey: currentSortedColumn,
								sortDesc: currentSortDesc,
								paging: currentSelectedPage,
								formating: currentPageFormating
							});
						};

						this.updateLocalSort = function() {
							if ('localSort' in $scope) {
								$scope.localSort = {
									column: currentSortedColumn,
									dir: currentSortDesc
								};
							}
						};

						this.updateStorage = function() {
							if (uniqueKey) {
								FiltersService.setFilter(uniqueKey, {
									column: currentSortedColumn,
									desc: currentSortDesc,
									currentSelectedPage: currentSelectedPage,
									currentPageFormating: currentPageFormating
								});
							}
						};

						this.getStorage = function() {
							if (uniqueKey) {
								return FiltersService.getFilter(uniqueKey);
							}
						};

						this.headerRegister = function(key, callBackControlls) {
							headerMap[key] = callBackControlls;

							if (sortingDisabled) {
								callBackControlls(COLUMN_ACTION_DISABLE_SORTING);
							}

							if (currentSortedColumn === key) {
								var updateOptions = {};
								updateOptions[COLUMN_ACTION_SORT_OPTION] = currentSortDesc ? COLUMN_ACTION_SORT_DESC : COLUMN_ACTION_SORT_ASC;
								callBackControlls(COLUMN_ACTION_SET_SORT, updateOptions);
							}
						};

						this.rowRegister = function(rowId, callBackFn) {
							rowMap[rowId] = callBackFn;
						};

						this.rowUnregister = function(rowId) {
							delete rowMap[rowId];
						};

						this.updateSort = function(columnKey, sortDesc) {

							currentSortDesc = sortDesc;

							if (currentSortedColumn !== null && columnKey !== currentSortedColumn) {
								headerMap[currentSortedColumn](COLUMN_ACTION_CLEAR);
							}

							currentSortedColumn = columnKey;

							self.updateStorage();

							self.updateLocalSort();

							this.sendParentControllerNotification();

						};
						this.pagingExternalChange = function(selectedPage) {
							currentSelectedPage = selectedPage;
							self.updateStorage();
						};

						this.selectPage = function(selectedPage) {
							currentSelectedPage = selectedPage;
							this.sendParentControllerNotification();
							self.updateStorage();
						};

						this.formatingExternalChange = function(format) {
							currentPageFormating = format;
							self.updateStorage();
						};

						this.selectFormat = function(format) {
							currentPageFormating = format;
							this.sendParentControllerNotification();
							self.updateStorage();
						};

						this.isObjectSelected = function() {
							for (var r in selectedObjects) {
								return !!r;
							}
							return false;
						};

						this.updateSelectedElements = function() {
							selectedObjects = {};
							for (var row in rowMap) {
								var info = rowMap[row](IS_ROW_SELECTED);
								if (info) {
									selectedObjects[info.index] = info.object;
								}
							}
						};

						this.selectElement = function(index, object) {
							if ($scope.selectionMode !== 'NONE') {
								selectedObjects[index] = object;
							}

							if ($scope.selectNotification) {
								$timeout(function() {
									$scope.selectNotification({
										index: index,
										data: object
									});
								});
							}
						};

						this.unselectElement = function(index, object, destroyed) {
							if (selectedObjects[index] !== undefined) {
								delete selectedObjects[index];
								if ($scope.selectNotification) {
									$timeout(function() {
										$scope.selectNotification({
											index: -1,
											service: null,
											data: object,
											destroyed: destroyed,
											oldIndex: index
										});
									});
								}
							}
						};

						this.selectAll = function() {
							// Only for multiple selection
							if (this.selectionMode === 'MULTIPLE') {
								for (var row in rowMap) {
									rowMap[row](ROW_ACTION_SELECT);
								}
							}
						};

						this.unselectAll = function() {
							for (var row in rowMap) {
								rowMap[row](ROW_ACTION_UNSELECT);
							}
						};

						this.sort = function(options) {
							if (options === undefined || options['columnKey'] === undefined || options['desc'] === undefined || headerMap[options['columnKey']]) {
								return;
							}
							var column = options['columnKey'];

							if (currentSortedColumn !== null && currentSortedColumn !== column) {
								headerMap[currentSortedColumn](COLUMN_ACTION_CLEAR);
							}

							currentSortedColumn = column;

							options['desc'] = (typeof options['desc']).toUpperCase() === 'STRING' ? options['desc'].toUpperCase() === 'TRUE' : options['desc'];

							var updateOptions = {};
							updateOptions[COLUMN_ACTION_SORT_OPTION] = options['desc'] ? COLUMN_ACTION_SORT_DESC : COLUMN_ACTION_SORT_ASC;
							headerMap[column](COLUMN_ACTION_SET_SORT, updateOptions);

							self.updateStorage();

							self.updateLocalSort();
						};

						this.setSelectionMode = function(mode) {
							self.selectionMode = mode;
						};

						var selectLine = function(index) {
							for (var row in rowMap) {
								rowMap[row](ROW_SELECT_IF_INDEX, parseInt(index));
							}
						};

						var getSelectedObjects = function() {
							self.updateSelectedElements();
							return selectedObjects;
						};

						var getCurrentState = function() {
							return {
								sortColumnKey: currentSortedColumn,
								sortDesc: currentSortDesc,
								paging: currentSelectedPage,
								formating: currentPageFormating
							};
						};

						var ctrlsCmd = {
							sort: self.sort,
							selectedObjects: getSelectedObjects,
							selectAll: self.selectAll,
							unselectAll: self.unselectAll,
							getCurrentState: getCurrentState,
							updateSelectedElements: self.updateSelectedElements,
							selectLine: selectLine,
							isObjectSelected: self.isObjectSelected,
							setSelectionMode: self.setSelectionMode
						};

						$scope.control = function(action, options) {
							if (ctrlsCmd[action]) {
								return ctrlsCmd[action](options);
							}
						};


					}]
			};
		}])
			.directive('stlTableHead', [function() {
					return {
						restrict: 'A',
						require: '^stlTable',
						replace: true,
						transclude: true,
						scope: {
							sortable: '@',
							key: '@'
						},
						template: '<th class="stl-table-th-head" ng-click="toggleSort()">' +
								'<div ng-transclude></div>' +
								'<div class="stl-table-sort-btns">' +
								// use span+font rather than png
								'<span class="iconbtn iconexp iconexp-navigate-up" ng-if="showDesc"></span>' +
								'<span class="iconbtn iconexp iconexp-navigate-down" ng-if="showAsc"></span>' +
								//'<div class="stl-table-sort-desc" ng-if="showDesc">desc</div>' +
								//'<div class="stl-table-sort-asc"  ng-if="showAsc">asc</div>' +
								'</div>' +
								'</th>',
						link: function(scope, element, attribute, controller) {
							var sortingEnabled = true;
							var key = scope.key;
							scope['showDesc'] = false;
							scope['showAsc'] = false;

							var colSortable = true;
							if (scope.sortable !== undefined && scope.sortable !== null) {
								colSortable = scope.sortable.toLowerCase() === 'true';
							}
							if (!colSortable) {
								$(element).addClass('stl-disable-table-sorting');
							}

							/**
							 *
							 * @param {String} action Nom de l'action à exécuter.
							 * @param {Object} options Options en fonction de l'action pour le passage de paramètres additionnels.
							 * @returns {undefined}
							 */
							var controlls = function(action, options) {
								var sort = action === COLUMN_ACTION_SET_SORT && options !== undefined && options[COLUMN_ACTION_SORT_OPTION] !== undefined;

								if (action === COLUMN_ACTION_CLEAR) {
									scope['showDesc'] = false;
									scope['showAsc'] = false;
								} else if (sort) {
									scope['showDesc'] = options[COLUMN_ACTION_SORT_OPTION] === COLUMN_ACTION_SORT_DESC;
									scope['showAsc'] = options[COLUMN_ACTION_SORT_OPTION] === COLUMN_ACTION_SORT_ASC;
								} else if (action === COLUMN_ACTION_DISABLE_SORTING) {
									sortingEnabled = false;
									$(element).addClass('stl-disable-table-sorting');
								} else if (action === COLUMN_ACTION_ENABLE_SORTING && colSortable) {
									sortingEnabled = true;
									$(element).removeClass('stl-disable-table-sorting');
								}
							};

							scope.toggleSort = function() {
								if (!sortingEnabled || !colSortable) {
									return;
								}
								if (scope['showAsc'] === false) {
									scope['showDesc'] = false;
									scope['showAsc'] = true;
									controller.updateSort(key, false);
								} else {
									scope['showDesc'] = true;
									scope['showAsc'] = false;
									controller.updateSort(key, true);
								}
							};

							controller.headerRegister(key, controlls);
						}
					};
				}])
			.directive('stlTableRowSelection', [function() {
					var uniqueId = 0;
					var ACTIVE_CLS = 'active';
					var UNSELECTABLE_CLS = 'unselectable';
					return {
						restrict: 'A',
						require: '^stlTable',
						scope: {
							stlTableRowSelection: '=',
							index: '=',
							disabled: '=?'
						},
						link: function(scope, element, attributes, controller) {
							//var sc = angular.element(element).scope(); retrive the ng-repeat scope
							var rowId = uniqueId++;
							var selectField = null;
							if (attributes['selectField']) {
								selectField = attributes['selectField'];
							}

							var updateSelectedFiled = function(value) {
								if (selectField !== null) {
									scope.stlTableRowSelection[selectField] = value;
								}
							};

							element.bind('$destroy', function() {
								if ($(element).hasClass(ACTIVE_CLS) && !attributes['noDestroyEvent']) {
									controller.unselectElement(scope.index, scope.stlTableRowSelection, true);
								}
								controller.rowUnregister(rowId);
							});

							$(element).on('click', function(ev) {
								if ($(element).hasClass(UNSELECTABLE_CLS)) {
									return;
								}
								if (controller.selectionMode !== 'NONE') {
									if ($(element).hasClass(ACTIVE_CLS)) {
										$(element).removeClass(ACTIVE_CLS);
										updateSelectedFiled(false);
										controller.unselectElement(scope.index, scope.stlTableRowSelection);
									} else {
										if (!scope.disabled && scope.disabled !== true) {
											if (controller.selectionMode === 'SINGLE') {
												controller.unselectAll();
											}
											updateSelectedFiled(true);
											$(element).addClass(ACTIVE_CLS);
											controller.selectElement(scope.index, scope.stlTableRowSelection);
										}

									}
								}

							});
							var callBackFn = function(action, options) {
								if (action === ROW_ACTION_SELECT && !$(element).hasClass(ACTIVE_CLS)) {
									$(element).addClass(ACTIVE_CLS);
									updateSelectedFiled(true);
									controller.selectElement(scope.index, scope.stlTableRowSelection);
								} else if (action === ROW_ACTION_UNSELECT && $(element).hasClass(ACTIVE_CLS)) {
									$(element).removeClass(ACTIVE_CLS);
									updateSelectedFiled(false);
									controller.unselectElement(scope.index, scope.stlTableRowSelection);
								} else if (action === IS_ROW_SELECTED && $(element).hasClass(ACTIVE_CLS)) {
									return {
										index: scope.index,
										object: scope.stlTableRowSelection
									};
								} else if (action === ROW_SELECT_IF_INDEX && options === scope.index) {
									$(element).addClass(ACTIVE_CLS);
									controller.selectElement(scope.index, scope.stlTableRowSelection);
								}
							};
							controller.rowRegister(rowId, callBackFn);
							if (selectField !== null && scope.stlTableRowSelection[selectField] === true) {
								$(element).addClass(ACTIVE_CLS);
								controller.selectElement(scope.index, scope.stlTableRowSelection);
							}
						}
					};
				}])
			.directive('stlTablePaging', ['$sce', '$translate', function ($sce, $translate) {
					return {
						restrict: 'AE',
						require: '^stlTable',
						replace: true,
						scope: {
							parameters: '=',
							pageCount: '=',
							selectedPage: '='
						},
						templateUrl: 'scripts/core/table/paginator.html',
						link: function(scope, element, attributes, controller) {
							var initNbPages = function(count, parameters) {
								var nbPages = Math.floor(count / parameters.totalElementsPerPage);
								if (count % parameters.totalElementsPerPage > 0) {
									nbPages++;
								}
								return nbPages;
							};
							var createPage = function(index) {
								return {
									label: index + 1,
									index: index
								};
							};
							var createNoPage = function() {
								return {
									label: '...',
									index: null
								};
							};
							var buildPages = function(count) {
								var pages = [];
								scope.count = count;
								if (count) {
									var nbPages = initNbPages(count, scope.parameters);
									scope.totalPages = nbPages;
									var selectedPage = scope.parameters.selectedPage;

									if (selectedPage + 1 > nbPages) {
										scope.selectPage(nbPages - 1);
									}

									var elemenentAfficheDu = (scope.parameters.totalElementsPerPage * selectedPage) + 1;
									var elemenentAfficheAu = elemenentAfficheDu + scope.parameters.totalElementsPerPage - 1;

									if (count < elemenentAfficheAu) {
										elemenentAfficheAu = count;
									}
									$translate('resultXaYsurZ', {x: elemenentAfficheDu, y: elemenentAfficheAu, z: count}).then(function (translatedValue) {
										//scope.elementsCount = $sce.trustAsHtml(I18nService.localize('resultXaYsurZ', [elemenentAfficheDu, elemenentAfficheAu, count]));
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});



									if (nbPages > 9) {
										var start;
										var end;

										start = selectedPage - 2;
										end = selectedPage + 2;

										var addStart = false;
										var addEnd = false;

										if (start < 2) {
											start = 0;
											end = 6;
										} else {
											addStart = true;
										}
										if (scope.totalPages - end < 2) {
											end = scope.totalPages-1;
											start = scope.totalPages - 6;
										} else {
											addEnd = true;
										}

										if (!!addStart) {
											pages.push(createPage(0));
											pages.push(createNoPage());
										}

										for (var i = start; i <= end; i++) {
											pages.push(createPage(i));
										}

										if (!!addEnd) {
											pages.push(createNoPage());
											pages.push(createPage(scope.totalPages-1));
										}

									} else {
										for (var j = 0; j < nbPages; j++) {
											pages.push(createPage(j));
										}
									}
								} else {
									$translate('AucunResultat').then(function (translatedValue) {
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});
								}
								scope.pages = pages;
							};
							buildPages(0);
							scope.$watchCollection('[parameters.selectedPage, parameters.count, parameters.totalElementsPerPage]', function() {
								if (scope.parameters.count || scope.parameters.count === 0) {
									buildPages(scope.parameters.count);
								} else {
									$translate('AucunResultat').then(function (translatedValue) {
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});
								}

							});

							scope.next = function() {
								scope.selectPage(scope.parameters.selectedPage + 1);
							};
							scope.prev = function() {
								scope.selectPage(scope.parameters.selectedPage - 1);
							};

							scope.selectPage = function(page) {
								scope.parameters.selectedPage = page;
								controller.selectPage(page);
							};
							scope.selectFormat = function(format) {
								scope.parameters.totalElementsPerPage = format;
								controller.selectFormat(format);
							};
							scope.$watch('parameters', function() {
								if (scope.parameters.pageFormating) {
									if (scope.parameters.totalElementsPerPage === undefined) {
										scope.parameters.totalElementsPerPage = scope.parameters.pageFormating[0];
										var storage = controller.getStorage();
										if (storage && storage['currentSelectedPage']) {
											scope.parameters.totalElementsPerPage = storage['currentPageFormating'];
											scope.parameters.selectedPage = storage['currentSelectedPage'];
										}

									}
									if (!scope.parameters.selectedPage) {
										scope.parameters.selectedPage = 0;
									}

									controller.formatingExternalChange(scope.parameters.totalElementsPerPage);

									controller.pagingExternalChange(scope.parameters.selectedPage);
								}

							}, true);
							if (scope.parameters) {
								controller.pagingExternalChange(scope.parameters.selectedPage);
							}
						}
					};
				}])
			/*.directive('stlTableBtns', [function() {
			 return {
			 restrict: 'E',
			 link: function(scope, element) {
			 // A voir si utile
			 /*$('button', element).addClass('btn');
			 $('button', element).attr('type', 'button');*
			 }
			 };
			 }]) */
			.directive('stlTableAction', [function() {
					return {
						restrict: 'A',
						require: '^stlTable',
						scope: {
							stlTableAction: '='
						},
						link: function(scope, element, attributes, controller) {
							element.on('click', function() {
								if (scope.stlTableAction === 'selectAll') {
									controller.selectAll();
								} else if (scope.stlTableAction === 'unselectAll') {
									controller.unselectAll();
								}
							});
						}
					};
				}])
			.directive('stlTableNoSelection', [function() {
					return {
						restrict: 'A',
						link: function(scope, element) {
							$(element).on('click', function(ev) {
								ev.stopPropagation();
							});
						}
					};
				}]);

	core.filter('stlTableLocalSortPaging', ['ObjectFilter', function(ObjectFilter) {
			return function(list, sortOptions, pagingOptions) {
				if (!list) {
					return null;
				} else if (!sortOptions) {
					return list;
				} else {
					return ObjectFilter.sortFilterArray(list, [sortOptions]);
				}
			};
		}]);

	core.filter('stlTableLocalSort', ['ObjectFilter', function(ObjectFilter) {
			return function(list, sortOptions) {
				if (!list) {
					return null;
				} else if (!sortOptions) {
					return list;
				} else {
					return ObjectFilter.sortFilterArray(list, [sortOptions]);
				}
			};
		}]);
})(angular);